const FrameVideo = {
  render: async () => `
    <div class='root'>
      <nav class='nav-wrap'></nav>
      <section class='main-wrap'></section>
      <aside class='aside-wrap'></aside>
    </div>
  `,
  after_render: async () => {

  }
}

export default FrameVideo;